import { SVGProps } from 'react'

/**
 * The mark for a held benefit, taken from the product mock-up's own icon set.
 *
 * Stroked with `currentColor` rather than filled with a brand color, because it is used at two
 * very different sizes and on two very different grounds — small inside a pale offer badge, and
 * larger on the dark blue of the settings sidebar — and in both it should take the color of the
 * text beside it.
 */
export const Gift = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <rect x="3" y="8" width="18" height="4" rx="1" />
    <path d="M5 12v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-8M12 8v13M12 8s-4.5.2-5.5-2C5.7 4.3 7 3 8.5 3c2.5 0 3.5 5 3.5 5Zm0 0s4.5.2 5.5-2C18.3 4.3 17 3 15.5 3c-2.5 0-3.5 5-3.5 5Z" />
  </svg>
)
